import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../localization/messages";
import PropTypes from "prop-types";
import React from "react";
import { SVGIcon2 } from "../common/SVGIconV2";

export const RightSideDrawerError = props => {
  const { drawer, onClose, onRetry } = props;
  const { appID } = drawer;
  return (
    <div className="right-side-drawer-wrapper">
      <div className="right-side-drawer-header">
        <div
          className="close-right-side-drawer"
          onClick={() => onClose(drawer)}
        >
          <SVGIcon2 iconName="cool_arrow" />
        </div>
        <h2>
          <FormattedMessage
            {...LocalizationMessages.rightSideDrawerHeader(appID)}
          />
        </h2>
      </div>
      <div className="right-side-drawer-error-body">
        <div className="right-side-drawer-flex-aligner">
          <i className="disconnect-icon"></i>
          <span className="error-title">
            <FormattedMessage {...LocalizationMessages.rightSideDrawerTitle} />
          </span>
          <p className="error-message">
            <FormattedMessage {...LocalizationMessages.rightSideDrawerBody} />
          </p>
          <button className="error-btn" onClick={() => onRetry(drawer)}>
            <FormattedMessage {...LocalizationMessages.rightSideDrawerRetry} />
          </button>
        </div>
      </div>
    </div>
  );
};

RightSideDrawerError.propTypes = {
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
  trackingInfo: PropTypes.shape({
    closeTracking: PropTypes.object,
    retryTracing: PropTypes.object
  }),
  drawer: PropTypes.object
};
